import { Service } from "typedi";
import { PublicStudentRulesDTO } from "../../../../../schools-backend/src/rule/application/stores/StudentRulesDTO";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { StudentRulesCache } from "../state/StudentRulesCache";
import { UrlEvaluator } from "../state/UrlEvaluator";

@Service()
export class SetStudentRules implements AgentRPCCommand<"set.student.rules"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly rulesCache: StudentRulesCache,
        private readonly urlEvaluator: UrlEvaluator
    ) {
        agentRPCCommands.register("set.student.rules", this);
    }

    async run(studentRules: PublicStudentRulesDTO): Promise<void> {
        this.rulesCache.set(studentRules);
        // Stale category verdicts may no longer reflect the updated rules;
        // discard them and let the next navigation re-query.
        this.urlEvaluator.clear();
    }
}
